'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { TextField as BaseTextField, Skeleton } from '@mui/material';
import { noop } from 'lodash';
export default function TextField({ defaultValue = '', value: valueProp = '', onChange = noop, loading, ...props }) {
    const [value, setValue] = useState(defaultValue || valueProp);
    useEffect(() => {
        setValue(defaultValue || valueProp);
    }, [defaultValue, valueProp]);
    const handleChange = (event) => {
        setValue(event.target.value);
        onChange(event);
    };
    if (loading) {
        return _jsx(Skeleton, { variant: "text" });
    }
    return _jsx(BaseTextField, { fullWidth: true, value: value, onChange: handleChange, ...props });
}
